import './index.scss'
import React from 'react'
import { CSpinner } from '@coreui/react-pro'

const Loader = () => {
  return (
    <div className="loader-container">
      <CSpinner variant="grow" color="primary" />
    </div>
  )
}

export default Loader
